module.exports = __webpack_public_path__ + "static/media/portrait_sophie.ad7a5b33.jpg";